import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../../common/Config";
import QuickBooksPushPrompt from "../../common/QuickBooksPushPrompt";
import { toast } from 'sonner';
import axios from 'axios';
import { Box, Typography, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid2, IconButton, FormControl, InputLabel, Select, MenuItem, Radio, RadioGroup, FormControlLabel, FormLabel, Checkbox } from '@mui/material';
import { Iconify } from '../../Minimal/src/components/iconify/iconify';
import '../../common/commonStyles.css';
import { encryptPayload, decryptPayload } from '../../../utils/customerCrypto';
import { getCompanySettings, resolveCustomerApiEncrypt } from '../../../utils/companySettingsCache';
import { fetchCustomerDynamicForm, resolveCustomerFormFieldName } from './customerDynamicFormApi';

const LOCKED_REQUIRED_FIELDS = new Set([
  "companyName",
  "firstName",
  "accound_no",
  "addressLine1",
  "addressLine2",
]);

const INITIAL_FORM_DATA = {
  companyName: '',
  firstName: '',
  emailId: '',
  phone: '',
  accound_no: '',
  route: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  postalCode: '',
  county: '',
  vatNo: '',
  default_delivery: '',
  typeOfBusiness: '',
  businessCategory: '',
  product_price: '',
  credit_facility: '',
  day_wise: '0',
  total_day: '',
  invoice_wise: '0',
  total_invoice: '',
  amount_wise: '0',
  total_amount: '',
  end_of_month: '0',
  end_of_month_day: '',
  shiptoName: '',
  shipLine1: '',
  shipLine2: '',
  shipCity: '',
  shipPostcode: '',
  shipState: '',
};

const AddCustomersForm = ({ open = false, onClose, useDynamicForm = false }) => {
  const accessToken = localStorage.getItem('accessToken');
  const userId = localStorage.getItem('userId');
  const company_tax_type = localStorage.getItem('company_tax_type');
  const isAtrPrefix = accessToken === 'atr' || config.PREFIX === 'atr';
  const [qbPromptOpen, setQbPromptOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [businessType, setBusinessType] = useState([]);
  const [businessRute, setBusinessRute] = useState([]);
  const [businessCategory, setBusinessCategory] = useState([]);
  const [errors, setErrors] = useState({});
  const [facilityError, setFacilityError] = useState('');
  const [sameAsBillTo, setSameAsBillTo] = useState(false);
  const [formData, setFormData] = useState(() => ({ ...INITIAL_FORM_DATA }));
  const navigateToCustomerList = useNavigate();
  const [creditFacility, setCreditFacility] = useState('0');
  const [qtyDiscount, setQtyDiscount] = useState('0');
  const [showCreditFacility, setShowCreditFacility] = useState(!useDynamicForm);
  const [showProductPrice, setShowProductPrice] = useState(!useDynamicForm);
  const [dynamicRequired, setDynamicRequired] = useState({});
  const [dynamicVisible, setDynamicVisible] = useState({});
  const [dynamicRulesReady, setDynamicRulesReady] = useState(false);

  const generateCustomerAccountNo = async () => {
    try {
      const formDataPayload = new FormData();
      formDataPayload.append('platform', 'web');
      formDataPayload.append('prefix', 'atr');
      const response = await axios.post(
        `${config.API_URL}/generate_customer_account_no`,
        formDataPayload,
        { headers: { authorization: `Bearer ${accessToken}` } }
      );
      const data = response?.data || {};
      if (data.success) {
        return String(data.account_no || data.accound_no || '').trim();
      }
    } catch (error) {
      console.error('Error generating account number:', error);
    }
    return '';
  };

  const fetchBusinessTypeList = async () => {
    const apiBTUrl = `${config.API_URL}/ws-get-business-types_web`;
    try {
      const response = await fetch(apiBTUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch brand list");
      const data = await response.json();
      const resolved =
        decryptPayload(data?.encrypted_payload) ||
        decryptPayload(data?.encrypted_data) ||
        decryptPayload(data?.payload) ||
        data;
      setBusinessType(resolved?.businessTypes ? resolved.businessTypes : []);
    } catch (error) {
      console.log("Error fetch brand list", error);
    }
  };

  const fetchBusinessCategoryList = async () => {
    const apiBCUrl = `${config.API_URL}/ws-get-business-categories_web`;
    try {
      const response = await fetch(apiBCUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch brand list");
      const data = await response.json();
      const resolved =
        decryptPayload(data?.encrypted_payload) ||
        decryptPayload(data?.encrypted_data) ||
        decryptPayload(data?.payload) ||
        data;
      setBusinessCategory(resolved?.businessCategories ? resolved.businessCategories : []);
    } catch (error) {
      console.log("Error fetch brand list", error);
    }
  };

  const fetchBusinessRouteList = async () => {
    const brForm = new FormData();
    brForm.append("platform", 'web');
    const apiBRUrl = `${config.API_URL}/getRoute`;
    try {
      const response = await fetch(apiBRUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: brForm,
      });
      if (!response.ok) throw new Error("Failed to fetch brand list");
      const data = await response.json();
      const resolved =
        decryptPayload(data?.encrypted_payload) ||
        decryptPayload(data?.encrypted_data) ||
        decryptPayload(data?.payload) ||
        data;
      setBusinessRute(resolved?.data ? resolved.data : []);
    } catch (error) {
      console.log("Error fetch brand list", error);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? '1' : '0',
      ...(name === 'end_of_month' && !checked ? { end_of_month_day: '' } : {}),
    }));
    if (name === 'end_of_month' && !checked) {
      setErrors((prev) => ({ ...prev, end_of_month_day: '' }));
    }
    setFacilityError('');
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchBusinessRouteList();
    fetchBusinessTypeList();
    fetchBusinessCategoryList();
  }, []);

  useEffect(() => {
    if (!open) return;
    setFormData({ ...INITIAL_FORM_DATA });
    setErrors({});
    setFacilityError('');
    setSameAsBillTo(false);
    setCreditFacility('0');
    setQtyDiscount('0');
    setIsSubmitting(false);
    if (!isAtrPrefix) return;
    let cancelled = false;
    (async () => {
      const accountNo = await generateCustomerAccountNo();
      if (cancelled || !accountNo) return;
      setFormData((prev) =>
        String(prev.accound_no || '').trim()
          ? prev
          : { ...prev, accound_no: accountNo }
      );
    })();
    return () => {
      cancelled = true;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    if (!useDynamicForm) {
      setShowCreditFacility(true);
      setShowProductPrice(true);
      return;
    }
    let cancelled = false;
    const findField = (fields, name) =>
      (fields || []).find((field) => {
        const key = resolveCustomerFormFieldName(field?.name || "");
        return key === name || field?.name === name;
      });
    const loadFieldVisibility = async () => {
      try {
        const form = await fetchCustomerDynamicForm({
          formKey: "add_customer",
          authToken: localStorage.getItem("token") || accessToken,
        });
        const sectionFields = (form?.sections || []).flatMap((section) => section.fields || []);
        const orderedFields = [];
        const seenFieldNames = new Set();
        const pushField = (field) => {
          const resolved = resolveCustomerFormFieldName(field?.name || "");
          const key = resolved || field?.name;
          if (!key || seenFieldNames.has(key)) return;
          seenFieldNames.add(key);
          orderedFields.push(field);
        };
        sectionFields.forEach(pushField);
        (form?.fields || []).forEach(pushField);
        const fields = orderedFields.length
          ? orderedFields
          : form?.fields?.length
            ? form.fields
            : sectionFields;
        const credit = findField(fields, "credit_facility");
        const productPrice = findField(fields, "product_price");
        const creditVisible = credit ? credit.visible !== false : false;
        const productPriceVisible = productPrice ? productPrice.visible !== false : false;
        const requiredMap = {};
        const visibleMap = {};
        (fields || []).forEach((field) => {
          const resolved = resolveCustomerFormFieldName(field?.name || "");
          const shown = field?.visible !== false;
          const isRequired = field?.required === true && shown;
          [field?.name, resolved, String(field?.name || "").toLowerCase(), String(resolved || "").toLowerCase()]
            .filter(Boolean)
            .forEach((key) => {
              requiredMap[key] = isRequired;
              visibleMap[key] = shown;
            });
        });
        if (cancelled) return;
        setDynamicRequired(requiredMap);
        setDynamicVisible(visibleMap);
        setDynamicRulesReady(true);
        setShowCreditFacility(creditVisible);
        setShowProductPrice(productPriceVisible);
        if (!creditVisible) {
          setCreditFacility("0");
          setFormData((prev) => ({ ...prev, credit_facility: "0" }));
        }
      } catch {
        if (!cancelled) {
          setDynamicRequired({});
          setDynamicVisible({});
          setDynamicRulesReady(false);
          setShowCreditFacility(false);
          setShowProductPrice(false);
          setCreditFacility("0");
        }
      }
    };
    loadFieldVisibility();
    return () => {
      cancelled = true;
    };
  }, [accessToken, open, useDynamicForm]);

  // Keep Ship To in sync when 'Same as Bill To' is enabled
  useEffect(() => {
    if (sameAsBillTo) {
      setFormData((prev) => ({
        ...prev,
        shiptoName: prev.firstName || prev.companyName || '',
        shipLine1: prev.addressLine1 || '',
        shipLine2: prev.addressLine2 || '',
        shipCity: prev.city || '',
        shipPostcode: prev.postalCode || '',
        shipState: prev.county || '',
      }));
    }
  }, [sameAsBillTo, formData.firstName, formData.companyName, formData.addressLine1, formData.addressLine2, formData.city, formData.postalCode, formData.county]);

  const handleSameAsBillToChange = (e) => {
    const checked = e.target.checked;
    setSameAsBillTo(checked);
    if (checked) {
      setFormData((prev) => ({
        ...prev,
        shiptoName: prev.firstName || prev.companyName || '',
        shipLine1: prev.addressLine1 || '',
        shipLine2: prev.addressLine2 || '',
        shipCity: prev.city || '',
        shipPostcode: prev.postalCode || '',
        shipState: prev.county || '',
      }));
    }
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setCreditFacility(value);
    if (value !== '1') {
      setFormData((prev) => ({
        ...prev,
        end_of_month: '0',
        end_of_month_day: '',
        day_wise: '0',
        total_day: '',
        invoice_wise: '0',
        total_invoice: '',
        amount_wise: '0',
        total_amount: '',
      }));
      setErrors((prev) => ({
        ...prev,
        end_of_month_day: '',
        total_day: '',
        total_invoice: '',
        total_amount: '',
      }));
    }
  };

  const endOfMonthDayOptions = Array.from({ length: 31 }, (_, i) => String(i + 1));

  const isFieldShown = (name) => {
    if (!useDynamicForm) return true;
    if (!dynamicRulesReady) return true;
    return dynamicVisible[name] === true;
  };

  const isFieldMandatory = (name, staticRequired) => {
    if (!useDynamicForm) return staticRequired;
    if (!isFieldShown(name)) return false;
    if (LOCKED_REQUIRED_FIELDS.has(name)) return true;
    if (!dynamicRulesReady) return false;
    return dynamicRequired[name] === true;
  };

  const validateForm = () => {
    const newErrors = {};
    let localFacilityError = '';
    const need = (name, staticRequired) => isFieldMandatory(name, staticRequired);

    if (!formData.companyName) {
      if (need("companyName", true)) newErrors.companyName = "Mention business Name.";
    } else if (formData.companyName.length < 2) {
      newErrors.companyName = "business name must consist of at least 2 characters.";
    } else if (formData.companyName.length > 255) {
      newErrors.companyName = "business name must not exceed 255 characters.";
    }

    if (!formData.firstName) {
      if (need("firstName", true)) newErrors.firstName = "Mention Name.";
    } else if (formData.firstName.length < 2) {
      newErrors.firstName = "Name must consist of at least 2 characters.";
    } else if (formData.firstName.length > 255) {
      newErrors.firstName = "Name must not exceed 255 characters.";
    }

    if (!formData.phone) {
      if (need("phone", true)) newErrors.phone = "Phone is Required.";
    } else if (!/^\d{10,12}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be between 10 and 12 digits.";
    }

    if (!formData.emailId) {
      if (need("emailId", company_tax_type !== 'GST')) newErrors.emailId = "Email is Required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      newErrors.emailId = "Please enter a valid email address.";
    }

    if (!formData.accound_no) {
      if (need("accound_no", true)) newErrors.accound_no = "Mention Name.";
    } else if (formData.accound_no.length < 2) {
      newErrors.accound_no = "Name must consist of at least 2 characters.";
    } else if (formData.accound_no.length > 15) {
      newErrors.accound_no = "Name must not exceed 15 digits.";
    }

    if (isFieldShown("route") && need("route", true) && !formData.route) {
      newErrors.route = "Mention Route.";
    }
    if (isFieldShown("typeOfBusiness") && need("typeOfBusiness", true) && !formData.typeOfBusiness) {
      newErrors.typeOfBusiness = "Mention typeOfBusiness.";
    }
    if (isFieldShown("businessCategory") && need("businessCategory", true) && !formData.businessCategory) {
      newErrors.businessCategory = "Mention businessCategory.";
    }
    if (isFieldShown("default_delivery") && need("default_delivery", true) && !formData.default_delivery) {
      newErrors.default_delivery = "Mention Delivery Days.";
    }

    if (!formData.addressLine1) {
      if (need("addressLine1", true)) newErrors.addressLine1 = "Mention Address Name.";
    } else if (formData.addressLine1.length < 2) {
      newErrors.addressLine1 = "Address name must consist of at least 2 characters.";
    } else if (formData.addressLine1.length > 255) {
      newErrors.addressLine1 = "Address name must not exceed 255 characters.";
    }

    if (!formData.addressLine2) {
      if (need("addressLine2", false)) newErrors.addressLine2 = "Mention Address 2.";
    } else if (formData.addressLine2.length < 2) {
      newErrors.addressLine2 = "Address 2 must consist of at least 2 characters.";
    } else if (formData.addressLine2.length > 255) {
      newErrors.addressLine2 = "Address 2 must not exceed 255 characters.";
    }

    if (isFieldShown("city")) {
      if (!formData.city) {
        if (need("city", true)) newErrors.city = "Mention city Name.";
      } else if (formData.city.length < 2) {
        newErrors.city = "city name must consist of at least 2 characters.";
      } else if (formData.city.length > 255) {
        newErrors.city = "city name must not exceed 255 characters.";
      }
    }

    if (!formData.county) {
      if (need("county", true)) newErrors.county = "Mention county Name.";
    } else if (formData.county.length < 2) {
      newErrors.county = "county name must consist of at least 2 characters.";
    } else if (formData.county.length > 255) {
      newErrors.county = "county name must not exceed 255 characters.";
    }

    if (!formData.postalCode) {
      if (need("postalCode", true)) newErrors.postalCode = "Mention postal code .";
    } else if (formData.postalCode.length < 2) {
      newErrors.postalCode = "postal code name must consist of at least 2 digit.";
    } else if (formData.postalCode.length > 255) {
      newErrors.postalCode = "postal code name must not exceed 255 digit.";
    }

    if (!formData.vatNo && need("vatNo", false)) {
      newErrors.vatNo = `${company_tax_type || "VAT"} Number is required.`;
    }

    if (!useDynamicForm && company_tax_type !== 'GST') {
      if (!formData.default_delivery && !formData.accound_no) {
        newErrors.default_delivery = "Provide Delivery Days or Username.";
        newErrors.accound_no = "Provide Delivery Days or Username.";
      }
    }

    // Facility-specific validations
    if (creditFacility === '1') {
      if (
        formData.day_wise !== '1' &&
        formData.invoice_wise !== '1' &&
        formData.amount_wise !== '1' &&
        formData.end_of_month !== '1'
      ) {
        localFacilityError = 'At least one facility is required when Credit Facility is selected.';
      }
      if (formData.day_wise === '1' && !formData.total_day && need("total_day", true)) {
        newErrors.total_day = "Total Days is required.";
      }
      if (formData.invoice_wise === '1' && !formData.total_invoice && need("total_invoice", true)) {
        newErrors.total_invoice = "Total Invoice is required.";
      }
      if (formData.amount_wise === '1' && !formData.total_amount && need("total_amount", true)) {
        newErrors.total_amount = "Total Amount is required.";
      }
      if (formData.end_of_month === '1' && !String(formData.end_of_month_day || '').trim()) {
        newErrors.end_of_month_day = "Day is required.";
      }
    }

    setFacilityError(localFacilityError);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0 && !localFacilityError;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    let fieldErrors = {};
    // Validate the input field immediately as the user types
    switch (name) {
      case 'companyName':
        if (!value) {
          fieldErrors.companyName = "Mention business Name.";
        } else if (value.length < 2) {
          fieldErrors.companyName = "business name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.companyName = "business name must not exceed 255 characters.";
        }
        if (!fieldErrors.companyName) fieldErrors.companyName = '';
        break;
      case 'firstName':
        if (!value) {
          fieldErrors.firstName = "Mention Name.";
        } else if (value.length < 2) {
          fieldErrors.firstName = "Name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.firstName = "Name must not exceed 255 characters.";
        }
        if (!fieldErrors.firstName) fieldErrors.firstName = '';
        break;
      case 'phone':
        if (!value) {
          fieldErrors.phone = "Phone is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.phone = "Phone number must be between 10 and 12 digits.";
        }
        if (!fieldErrors.phone) fieldErrors.phone = '';
        break;
      case 'emailId':
        if (company_tax_type !== 'GST') {
          if (!value) {
            fieldErrors.emailId = "Email is Required.";
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            fieldErrors.emailId = "Please enter a valid email address.";
          }
        } else if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          fieldErrors.emailId = "Please enter a valid email address.";
        }
        if (!fieldErrors.emailId) fieldErrors.emailId = '';
        break;
      case 'accound_no':
        if (!value) {
          fieldErrors.accound_no = "Account Number is Required.";
        } else if (value.length < 2) {
          fieldErrors.accound_no = "No consist of at least 2 digits.";
        } else if (value.length > 15) {
          fieldErrors.accound_no = "No must not exceed 15 digits.";
        }
        if (!fieldErrors.accound_no) fieldErrors.accound_no = '';
        break;      
      case 'route':
        if (!value) {
          fieldErrors.route = "Mention route.";
        } 
        if (!fieldErrors.route) fieldErrors.route = '';
        break;
      case 'typeOfBusiness':
        if (!value) {
          fieldErrors.typeOfBusiness = "Mention typeOfBusiness.";
        } 
        if (!fieldErrors.typeOfBusiness) fieldErrors.typeOfBusiness = '';
        break;
      case 'businessCategory':
        if (!value) {
          fieldErrors.businessCategory = "Mention businessCategory.";
        } 
        if (!fieldErrors.businessCategory) fieldErrors.businessCategory = '';
        break;
      case 'default_delivery':
        if (!value) {
          fieldErrors.default_delivery = "Mention Delivery Days.";
        } 
        if (!fieldErrors.default_delivery) fieldErrors.default_delivery = '';
        break;
      case 'addressLine1':
        if (!value) {
          fieldErrors.addressLine1 = "Mention Address.";
        } else if (value.length < 2) {
          fieldErrors.addressLine1 = "Address must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.addressLine1 = "Address must not exceed 255 characters.";
        }
        if (!fieldErrors.addressLine1) fieldErrors.addressLine1 = '';
        break;
      case 'city':
        if (!value) {
          fieldErrors.city = "Mention city.";
        } else if (value.length < 2) {
          fieldErrors.city = "city must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.city = "city must not exceed 255 characters.";
        }
        if (!fieldErrors.city) fieldErrors.city = '';
        break;
      case 'county':
        if (!value) {
          fieldErrors.county = "Mention county.";
        } else if (value.length < 2) {
          fieldErrors.county = "county must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.county = "county must not exceed 255 characters.";
        }
        if (!fieldErrors.county) fieldErrors.county = '';
        break;
      case 'postalCode':
        if (!value) {
          fieldErrors.postalCode = "Mention postal code.";
        } else if (value.length < 2) {
          fieldErrors.postalCode = "postal code must consist of at least 2 digit.";
        } else if (value.length > 255) {
          fieldErrors.postalCode = "postal code must not exceed 255 digit.";
        }
        if (!fieldErrors.postalCode) fieldErrors.postalCode = '';
        break;
    }
    // Facility-specific field validation
    if (creditFacility === '1') {
      if (name === 'total_day' && formData.day_wise === '1' && !value) {
        fieldErrors.total_day = "Total Days is required.";
      }
      if (name === 'total_invoice' && formData.invoice_wise === '1' && !value) {
        fieldErrors.total_invoice = "Total Invoice is required.";
      }
      if (name === 'total_amount' && formData.amount_wise === '1' && !value) {
        fieldErrors.total_amount = "Total Amount is required.";
      }
    }
    if (
      useDynamicForm &&
      !LOCKED_REQUIRED_FIELDS.has(name) &&
      dynamicRulesReady &&
      dynamicRequired[name] !== true &&
      !String(value ?? "").trim()
    ) {
      fieldErrors[name] = "";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      ...fieldErrors
    }));
  };

  const submitAddCustomerForm = async () => {
    if (!validateForm()) return;

    if (
      creditFacility === '1' &&
      formData.day_wise !== '1' &&
      formData.invoice_wise !== '1' &&
      formData.amount_wise !== '1' &&
      formData.end_of_month !== '1'
    ) {
      setFacilityError('At least one facility is required when Credit Facility is selected.');
      return;
    }
    setFacilityError('');
    setIsSubmitting(true);
    
    const formPayload = new FormData();
    const requestPayload = {
      user_id: userId,
      companyName: formData.companyName,
      firstName: formData.firstName,
      emailId: formData.emailId,
      phone: formData.phone,
      accound_no: formData.accound_no,
      route: formData.route,
      addressLine1: formData.addressLine1,
      addressLine2: formData.addressLine2 || '',
      city: formData.city,
      postalCode: formData.postalCode,
      county: formData.county,
      vatNo: formData.vatNo || '',
      default_delivery: formData.default_delivery,
      typeOfBusiness: formData.typeOfBusiness,
      businessCategory: formData.businessCategory,
      product_price: formData.product_price || '',
      credit_facility: creditFacility,
      day_wise: creditFacility === '1' ? formData.day_wise : '0',
      total_day: creditFacility === '1' ? (formData.total_day || '') : '',
      invoice_wise: creditFacility === '1' ? formData.invoice_wise : '0',
      total_invoice: creditFacility === '1' ? (formData.total_invoice || '') : '',
      amount_wise: creditFacility === '1' ? formData.amount_wise : '0',
      total_amount: creditFacility === '1' ? (formData.total_amount || '') : '',
      end_of_month: creditFacility === '1' ? formData.end_of_month : '0',
      end_of_month_day:
        creditFacility === '1' && formData.end_of_month === '1'
          ? (formData.end_of_month_day || '')
          : '',
      shiptoName: company_tax_type === 'GST' ? formData.shiptoName || '' : '',
      shipLine1: company_tax_type === 'GST' ? formData.shipLine1 || '' : '',
      shipLine2: company_tax_type === 'GST' ? formData.shipLine2 || '' : '',
      shipCity: company_tax_type === 'GST' ? formData.shipCity || '' : '',
      shipPostcode: company_tax_type === 'GST' ? formData.shipPostcode || '' : '',
      shipState: company_tax_type === 'GST' ? formData.shipState || '' : '',
    };
    const settings = await getCompanySettings();
    const useEncrypt = resolveCustomerApiEncrypt(settings);
    if (useEncrypt) {
      const encryptedPayload = encryptPayload(requestPayload);
      if (!encryptedPayload) {
        toast.error("Encryption key missing.");
        setIsSubmitting(false);
        return;
      }
      formPayload.append('encrypted_payload', encryptedPayload);
    } else {
      const tenantPrefix = localStorage.getItem('accessToken');
      if (tenantPrefix) {
        formPayload.append('platform', 'web');
        formPayload.append('prefix', tenantPrefix);
      }
      Object.entries(requestPayload).forEach(([key, value]) => {
        formPayload.append(key, value == null ? '' : String(value));
      });
    }

    try {
      const response = await axios.post(`${config.API_URL}/add_customer_details`, formPayload, {
        headers: {
          authorization: `Bearer ${accessToken}`,
        }
      });
      const raw = response.data;
      const result = useEncrypt
        ? (decryptPayload(raw?.encrypted_payload) ||
            decryptPayload(raw?.encrypted_data) ||
            decryptPayload(raw?.payload) ||
            raw)
        : raw;
      const msg = result.message;
      if (result.success == true) {
        toast.success("Customer added successfully.");
        if (isAtrPrefix) {
          setQbPromptOpen(true);
        } else {
          setTimeout(() => {
            handleCloseDialog();
          }, 1500);
        }
      } else {
        toast.error(msg || "Failed to add customer.");
      }
    } catch (error) {
      console.error("Error add customer:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseDialog = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleCloseDialog();
          }
        }}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '90vh',
          }
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3,mb: -5}}>
          <Typography className="page-title">
            Add Customer
          </Typography>
          <IconButton onClick={handleCloseDialog} sx={{ p: 0.5 }}>
            <Iconify icon="eva:close-fill" width={20} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 0 }}>
          <Box component="form" id="addcustomerform" sx={{ pt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.primary' }}>
              Please fill in the information below. The field labels marked with <span style={{ color: 'red' }}>*</span> are required input fields.
            </Typography>
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                   className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Business Name"
                  name="companyName"
                  id="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  required={isFieldMandatory("companyName", true)}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                    className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Customer Name"
                  name="firstName"
                  id="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  required={isFieldMandatory("firstName", true)}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
              className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Email Address"
                  name="emailId"
                  id="emailId"
                  type="email"
                  value={formData.emailId}
                  onChange={handleChange}
                  error={!!errors.emailId}
                  helperText={errors.emailId}
                  required={isFieldMandatory("emailId", company_tax_type !== 'GST')}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                     className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Phone"
                  name="phone"
                  id="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  required={isFieldMandatory("phone", true)}
                  inputProps={{
                    style: {
                      appearance: "none",
                      MozAppearance: "textfield",
                    }
                  }}
                />
              </Grid2>

              {isFieldShown("route") && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required={isFieldMandatory("route", true)} error={!!errors.route}>
                  <InputLabel>Route</InputLabel>
                  <Select
                    name="route"
                    value={formData.route}
                    label="Route"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                        {businessRute.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                              {type.route_number}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.route && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.route}</Typography>}
                </FormControl>
              </Grid2>
              )}
              {isFieldShown("typeOfBusiness") && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required={isFieldMandatory("typeOfBusiness", true)} error={!!errors.typeOfBusiness}>
                  <InputLabel>Type of Business</InputLabel>
                  <Select
                    name="typeOfBusiness"
                    value={formData.typeOfBusiness}
                    label="Type of Business"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                          {businessType.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                              {type.type_business}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.typeOfBusiness && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.typeOfBusiness}</Typography>}
                </FormControl>
              </Grid2>
              )}
              {isFieldShown("businessCategory") && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required={isFieldMandatory("businessCategory", true)} error={!!errors.businessCategory}>
                  <InputLabel>Business Category</InputLabel>
                  <Select
                    name="businessCategory"
                    value={formData.businessCategory}
                    label="Business Category"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                       {businessCategory.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                            {type.category_name}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.businessCategory && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.businessCategory}</Typography>}
                </FormControl>
              </Grid2>
              )}
              {isFieldShown("default_delivery") && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required={isFieldMandatory("default_delivery", company_tax_type !== 'GST')} error={!!errors.default_delivery}>
                  <InputLabel>Delivery Days</InputLabel>
                  <Select
                    name="default_delivery"
                    value={formData.default_delivery}
                    label="Delivery Days"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="2">1 Days Delivery</MenuItem>
                    <MenuItem value="1">3 Days Delivery</MenuItem>
                    <MenuItem value="3">7 Days Delivery</MenuItem>
                  </Select>
                  {errors.default_delivery && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.default_delivery}</Typography>}
                </FormControl>
              </Grid2>
              )}

              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                        className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Address"
                  name="addressLine1"
                  id="addressLine1"
                  value={formData.addressLine1}
                  onChange={handleChange}
                  error={!!errors.addressLine1}
                  helperText={errors.addressLine1}
                  required={isFieldMandatory("addressLine1", true)}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                      className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Address 2"
                  name="addressLine2"
                  id="addressLine2"
                  value={formData.addressLine2 || ''}
                  onChange={handleChange}
                  error={!!errors.addressLine2}
                  helperText={errors.addressLine2}
                  required={isFieldMandatory("addressLine2", false)}
                />
              </Grid2>
              {isFieldShown("city") && (
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                   className="input-border text-field"
                  fullWidth
                  size="small"
                  label="City"
                  name="city"
                  id="city"
                  value={formData.city}
                  onChange={handleChange}
                  error={!!errors.city}
                  helperText={errors.city}
                  required={isFieldMandatory("city", true)}
                />
              </Grid2>
              )}
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
              className="input-border text-field"
                  fullWidth
                  size="small"
                  label={company_tax_type === 'GST' ? 'State' : 'County'}
                  name="county"
                  id="county"
                  value={formData.county}
                  onChange={handleChange}
                  error={!!errors.county}
                  helperText={errors.county}
                  required={isFieldMandatory("county", true)}
                />
              </Grid2>


              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                         className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Postal Code"
                  name="postalCode"
                  id="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                  error={!!errors.postalCode}
                  helperText={errors.postalCode}
                  required={isFieldMandatory("postalCode", true)}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
              className="input-border text-field"
                  fullWidth
                  size="small"
                  label="Account Number (User Name)"
                  name="accound_no"
                  id="accound_no"
                  value={formData.accound_no}
                  onChange={handleChange}
                  error={!!errors.accound_no}
                  helperText={errors.accound_no}
                  required={isFieldMandatory("accound_no", company_tax_type !== 'GST')}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                        className="input-border text-field"
                  fullWidth
                  size="small"
                  label={`${company_tax_type} Number`}
                  name="vatNo"
                  id="vatNo"
                  value={formData.vatNo || ''}
                  onChange={handleChange}
                  error={!!errors.vatNo}
                  helperText={errors.vatNo}
                  required={isFieldMandatory("vatNo", false)}
                />
              </Grid2>
                 {company_tax_type === 'GST' && (
                <>
                  <Grid2 size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        Ship To Details
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={sameAsBillTo}
                            onChange={handleSameAsBillToChange}
                          />
                        }
                        label="Same as Bill To"
                      />
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <TextField
                      className="input-border text-field"
                      fullWidth
                      size="small"
                      label="Name"
                      name="shiptoName"
                      id="shiptoName"
                      value={formData.shiptoName}
                      onChange={handleChange}
                      disabled={sameAsBillTo}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <TextField      
                     className="input-border text-field"
                      fullWidth
                      size="small"
                      label="Address Line 1"
                      name="shipLine1"
                      id="shipLine1"
                      value={formData.shipLine1}
                      onChange={handleChange}
                      disabled={sameAsBillTo}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <TextField
                     className="input-border text-field"
                      fullWidth
                      size="small"
                      label="Address Line 2"
                      name="shipLine2"
                      id="shipLine2"
                      value={formData.shipLine2}
                      onChange={handleChange}
                      disabled={sameAsBillTo}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <TextField
                        className="input-border text-field"
                      fullWidth
                      size="small"
                      label="City"
                      name="shipCity"
                      id="shipCity"
                      value={formData.shipCity}
                      onChange={handleChange}
                      disabled={sameAsBillTo}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <TextField
                          className="input-border text-field"
                      fullWidth
                      size="small"
                      label="Postcode"
                      name="shipPostcode"
                      id="shipPostcode"
                      value={formData.shipPostcode}
                      onChange={handleChange}
                      disabled={sameAsBillTo}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <TextField
                          className="input-border text-field"
                      fullWidth
                      size="small"
                      label="State"
                      name="shipState"
                      id="shipState"
                      value={formData.shipState}
                      onChange={handleChange}
                      disabled={sameAsBillTo}
                    />
                  </Grid2>
                </>
              )}

              {showProductPrice && (
              <Grid2 size={{ xs: 12}}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" variant="caption" sx={{fontWeight: 500, color: '#000'}}>Product Price</FormLabel>
                  <RadioGroup
                    row
                    name="product_price"
                    value={formData.product_price}
                    onChange={handleChange}
                    sx={{
                      marginTop: -1.5
                    }}
                  >
                    <FormControlLabel value="1" control={<Radio className="checkBox" />} label="Price 1" />
                    <FormControlLabel value="2" control={<Radio className="checkBox" />} label="Price 2" />
                    <FormControlLabel value="3" control={<Radio className="checkBox" />} label="Price 3" />
                    <FormControlLabel value="4" control={<Radio className="checkBox" />} label="Price 4" />
                    <FormControlLabel value="5" control={<Radio className="checkBox" />} label="Price 5" />
                    <FormControlLabel value="6" control={<Radio className="checkBox" />} label="Price 6" />
                  </RadioGroup>
                </FormControl>
              </Grid2>
              )}

              <Grid2 size={{ xs: 12 }}>
                <FormControl component="fieldset">
                  {showCreditFacility && (
                    <FormLabel component="legend" variant="caption" sx={{fontWeight: 500, color: '#000'}}>Credit Facility</FormLabel>
                  )}
                  <RadioGroup
                      sx={{
                        marginTop: showCreditFacility ? -1.5 : 0
                      }}
                    name="credit_facility"
                    value={showCreditFacility ? creditFacility : "0"}
                    onChange={showCreditFacility ? handleRadioChange : undefined}
                  >
                    {showCreditFacility && (
                      <FormControlLabel value="1" control={<Radio className="checkBox" />} label="Credit Facility" />
                    )}
                    <FormControlLabel value="0" control={<Radio className="checkBox" />} label="Credit Facility Cash" />
                  </RadioGroup>
                </FormControl>
              </Grid2>

              {creditFacility === '1' && (
                <Grid2 size={{ xs: 12, sm: 9 }}>
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <Box className="border-box" sx={{ p: 2}}>
                        <FormControlLabel
                       
                          control={
                            <Checkbox
                              className="checkBox"
                              name="day_wise"
                              checked={formData.day_wise === '1'}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Day Wise"
                        />
                        {formData.day_wise === '1' && (
                          <Box sx={{ mt: 2 }}>
                            <TextField
                              className="form-input-border"
                              fullWidth
                              size="small"
                              label="Total Days"
                              name="total_day"
                              value={formData.total_day}
                              onChange={handleChange}
                              error={!!errors.total_day}
                              helperText={errors.total_day}
                            />
                          </Box>
                        )}
                      </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <Box className="border-box" sx={{ p: 2}}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              className="checkBox"
                              name="invoice_wise"
                              checked={formData.invoice_wise === '1'}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Invoice Wise"
                        />
                        {formData.invoice_wise === '1' && (
                          <Box sx={{ mt: 2 }}>
                            <TextField
                              className="form-input-border"
                              fullWidth
                              size="small"
                              label="Total Invoice"
                              name="total_invoice"
                              value={formData.total_invoice}
                              onChange={handleChange}
                              error={!!errors.total_invoice}
                              helperText={errors.total_invoice}
                            />
                          </Box>
                        )}
                      </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <Box className="border-box" sx={{ p: 2}}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              className="checkBox"
                              name="amount_wise"
                              checked={formData.amount_wise === '1'}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Amount Wise"
                        />
                        {formData.amount_wise === '1' && (
                          <Box sx={{ mt: 2 }}>
                            <TextField
                              className="form-input-border"
                              fullWidth
                              size="small"
                              label="Total Amount"
                              name="total_amount"
                              value={formData.total_amount}
                              onChange={handleChange}
                              error={!!errors.total_amount}
                              helperText={errors.total_amount}
                            />
                          </Box>
                        )}
                      </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <Box className="border-box" sx={{ p: 2}}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              className="checkBox"
                              name="end_of_month"
                              checked={formData.end_of_month === '1'}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="End of the Month"
                        />
                        {formData.end_of_month === '1' && (
                          <Box sx={{ mt: 2 }}>
                            <FormControl
                              className="form-input-border"
                              fullWidth
                              size="small"
                              required
                              error={!!errors.end_of_month_day}
                            >
                              <InputLabel>Day</InputLabel>
                              <Select
                                name="end_of_month_day"
                                label="Day"
                                value={formData.end_of_month_day || ''}
                                onChange={handleChange}
                              >
                                <MenuItem value="">Select Day</MenuItem>
                                {endOfMonthDayOptions.map((day) => (
                                  <MenuItem key={day} value={day}>
                                    {day}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors.end_of_month_day ? (
                                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
                                  {errors.end_of_month_day}
                                </Typography>
                              ) : null}
                            </FormControl>
                          </Box>
                        )}
                      </Box>
                    </Grid2>
                  </Grid2>
                  {facilityError && (
                    <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                      {facilityError}
                    </Typography>
                  )}
                </Grid2>
              )}

            </Grid2>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={handleCloseDialog} 
          className='button-variant-outlined'
          variant='outlined'
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={submitAddCustomerForm}
            disabled={isSubmitting}
            className="button-variant-contained"
          >
            {isSubmitting ? 'Adding Customer...' : 'Add Customer'}
          </Button>
        </DialogActions>
      </Dialog>
      <QuickBooksPushPrompt
        open={qbPromptOpen}
        pushPath="customers"
        onDone={() => {
          setQbPromptOpen(false);
          handleCloseDialog();
        }}
      />
    </>
  );
};

export default AddCustomersForm;
